// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import moment from 'moment';
import VeeValidate from 'vee-validate';
import firebase from 'firebase';
// import InstantSearch from 'vue-instantsearch';
import App from './App';
import router from './router';

const validateConfig = {
  classNames: {
    touched: 'touched', // the control has been blurred
    untouched: 'untouched', // the control hasn't been blurred
    valid: 'valid', // model is valid
    invalid: 'invalid', // model is invalid
    pristine: 'pristine', // control has not been interacted with
    dirty: 'dirty', // control has been interacted with
  },
};

Vue.use(VeeValidate, validateConfig);
// Vue.use(InstantSearch);

Vue.config.productionTip = false;

// Add a filter to format a date
Vue.filter('formatDate', (value) => {
  if (value) {
    return moment(value).format('MM/DD/YYYY hh:mm');
  }
  return value;
});

// Add a filter to format a date
Vue.filter('formatJustDate', (value) => {
  if (value) {
    return moment(value.toISOString()).format('MM/DD/YYYY');
  }
  return value;
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  components: { App },
  router,
  created() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.$router.push('/plates');
      } else {
        this.$router.push('/login');
      }
    });
  },
});



// WEBPACK FOOTER //
// ./src/main.js